import { DocumentationLegacyPageAsset, } from "../SDKDocumentationLegacyPageAsset";
import { DocumentationLegacyPageBlock, } from "../SDKDocumentationLegacyPageBlock";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyPageBlockImage extends DocumentationLegacyPageBlock {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, children) {
        var _a, _b, _c, _d, _e;
        super(model, children);
        this.url = (_c = (_a = model.assetUrl) !== null && _a !== void 0 ? _a : (_b = model.asset) === null || _b === void 0 ? void 0 : _b.url) !== null && _c !== void 0 ? _c : null;
        // @ts-expect-error TS(2322): Type 'DocumentationLegacyPageAsset | null' is not ... Remove this comment to see the full error message
        this.asset = ((_d = model.asset) === null || _d === void 0 ? void 0 : _d.id)
            ? new DocumentationLegacyPageAsset(model.asset)
            : null;
        this.caption = (_e = model.caption) !== null && _e !== void 0 ? _e : null;
        this.alignment = model.alignment;
    }
}
